import React from "react";
import {
  Flex,
  Box,
  Text,
  Image,
  Grid,
  Icon,
  VStack,
  Heading,
} from "@chakra-ui/react";
import { cuate, vector } from "../../../../assets/exports";
import { FaCheckCircle } from "react-icons/fa";

const FourthLayer = () => {
  return (
    <Flex
      minH="100vh"
      pt="90px"
      pl={["0", "55px", "55px", "10px"]}
      pr={["0", "55px", "55px", "10px"]}
      mb="100px"
      w="100%"
      gap={{ base: "52px", md: "82px" }}
      align="center"
      flexDir={["column", "column", "column", "column"]}
      justifyContent="space-between"
    >
      <Box
        p={{ base: 6, md: 10 }}
        boxShadow="md"
        bg="#F5EFF4"
        borderTop="2px solid #191A23"
        borderLeft="2px solid #191A23"
        borderRight="2px solid #191A23"
        borderBottom="5px solid #191A23"
        borderRadius={{ base: "8px", md: "45px" }}
        justifyContent="space-between"
        py={{ base: "48px", md: "70px" }}
        px={{ base: "20px", md: "40px", lg: "50px" }}
      >
        <Flex
          justifyContent="space-between"
          direction={{ base: "column", md: "row" }}
          align="center"
        >
          <VStack align="flex-start" spacing={4} flex="1">
            <Box
              px="19px"
              borderRadius="6px"
              mb="30px"
              w="fit-content"
              py="5px"
              bg="#fff"
              mx={{ base: "auto", md: "unset" }}
            >
              <Text
                fontSize={["24px", "24px", "24px", "46px"]}
                fontWeight={500}
              >
                Our Mission
              </Text>
            </Box>
            <Flex color="#FF9D16">
              <Icon
                display={{ base: "none", md: "block" }}
                as={FaCheckCircle}
                w={8}
                h={8}
                mr={2}
              />
              <Text
                fontSize={["14px", "18px", "20px"]}
                color="#0F172B"
                textAlign={{ base: "center", md: "left" }}
              >
                Our mission is to leverage cutting-edge technology to create
                innovative solutions that address the critical needs of
                education and business management, thereby empowering
                individuals and organizations to achieve their full potential.
              </Text>
            </Flex>
          </VStack>
          <Box flex="1" mt={{ base: 6, md: 0 }}>
            <Image
              ml={{ base: "unset", md: "auto" }}
              src={cuate}
              boxSize={{ base: "100%", md: "400px" }}
              objectFit="contain"
            />
          </Box>
        </Flex>
      </Box>
      <Box
        p={{ base: 6, md: 10 }}
        boxShadow="md"
        bg="#F9F3EE"
        borderTop="2px solid #191A23"
        borderLeft="2px solid #191A23"
        borderRight="2px solid #191A23"
        borderBottom="5px solid #191A23"
        borderRadius={{ base: "8px", md: "45px" }}
        justifyContent="space-between"
        py={{ base: "48px", md: "70px" }}
        px={{ base: "20px", md: "40px", lg: "50px" }}
      >
        <Flex direction={{ base: "column-reverse", md: "row" }} align="center">
          <Box flex="1" mt={{ base: 6, md: 0 }}>
            <Image
              src={vector}
              boxSize={{ base: "100%", md: "400px" }}
              objectFit="contain"
            />
          </Box>
          <VStack align="flex-start" spacing={4} flex="1">
            <Box
              px="19px"
              borderRadius="6px"
              mb="30px"
              w="fit-content"
              py="5px"
              bg="#fff"
              mx={{ base: "auto", md: "unset" }}
            >
              <Text
                fontSize={["24px", "24px", "24px", "46px"]}
                fontWeight={500}
              >
                Our Vision
              </Text>
            </Box>
            <Flex color="#7B47CC">
              <Icon
                display={{ base: "none", md: "block" }}
                as={FaCheckCircle}
                w={8}
                h={8}
                mr={2}
              />
              <Text
                fontSize={["14px", "18px", "20px"]}
                color="#0F172B"
                textAlign={{ base: "center", md: "left" }}
              >
                At Fastamoni, we value innovation, efficiency, and empowerment.
                Our commitment is to provide cutting-edge financial technology
                solutions that simplify complex processes, enhance transaction
                security, and empower our users—whether educational institutions
                or businesses—to achieve their financial goals with ease and
                confidence. We strive to foster financial inclusivity and drive
                growth through seamless, reliable, and cost-effective financial
                management tools.
              </Text>
            </Flex>
          </VStack>
        </Flex>
      </Box>
    </Flex>
  );
};

export default FourthLayer;
